export default __webpack_public_path__ + "static/media/error.19e81851.svg";